
export interface IVIPCertificatePipelineTest {
	done?: boolean;
	self?: boolean;
	subcontractor?: string;
	length?: string;
}

export function createCertificatePipelineTest() {
	return {
		done: false,
		self: false,
		subcontractor: "",
		length: "",
	};
}

export function checkCertificatePipelineTest(data: IVIPCertificatePipelineTest) {
	if (data.done === undefined) {
		data.done = false;
	}
	if (data.self === undefined) {
		data.self = false;
	}
	if (data.subcontractor === undefined) {
		data.subcontractor = "";
	}
	if (data.length === undefined) {
		data.length = "";
	}
}
